var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-default" }, [
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _c("h4", { staticClass: "m-0" }, [
          _c("a", { attrs: { href: _vm.guide.url } }, [
            _vm._v(_vm._s(_vm.guide.title)),
          ]),
        ]),
        _vm._v(" "),
        _c("vue-metadata", { attrs: { guide: _vm.guide } }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row no-gutters" },
          [
            _c("vue-tags", {
              staticClass: "mt-2 mb-2",
              attrs: { tags: _vm.guide.tags },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ml-auto text-right" },
              [
                _c("p", { staticClass: "text-muted font-weight-bold mb-1" }, [
                  _c("i", { staticClass: "fas fa-fw fa-chart-line" }),
                  _vm._v(" " + _vm._s(_vm.seniorityLabel)),
                ]),
                _vm._v(" "),
                _c("vue-progress-bar", {
                  attrs: {
                    editable: false,
                    tooltips: Object.values(_vm.roles),
                  },
                  model: {
                    value: _vm.progressBarValue,
                    callback: function ($$v) {
                      _vm.progressBarValue = $$v
                    },
                    expression: "progressBarValue",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("ul", { staticClass: "list-inline text-muted small mt-1 mb-0" }, [
          _c("li", { staticClass: "list-inline-item" }, [
            _c(
              "a",
              {
                staticClass: "text-muted",
                attrs: {
                  href: "javascript:",
                  title: "Kliknij jeżeli uważasz ten wpis za wartościowy",
                },
                on: {
                  click: function ($event) {
                    return _vm.checkAuth(_vm.vote, _vm.guide)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa-fw fa-thumbs-up",
                  class: {
                    "fa text-primary": _vm.guide.is_voted,
                    far: !_vm.guide.is_voted,
                  },
                }),
                _vm._v(
                  "\n\n          " +
                    _vm._s(_vm.guide.votes) +
                    " " +
                    _vm._s(
                      _vm._f("declination")(_vm.guide.votes, [
                        "głos",
                        "głosy",
                        "głosów",
                      ])
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-inline-item" }, [
            _c(
              "a",
              {
                staticClass: "text-muted",
                attrs: {
                  href: "javascript:",
                  title: "Otrzymuj powiadomienia o zmianach na tej stronie",
                },
                on: {
                  click: function ($event) {
                    return _vm.checkAuth(_vm.subscribe, _vm.guide)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa-fw fa-bell",
                  class: {
                    "fa text-primary": _vm.guide.is_subscribed,
                    far: !_vm.guide.is_subscribed,
                  },
                }),
                _vm._v(
                  "\n\n          " +
                    _vm._s(_vm.guide.subscribers) +
                    " " +
                    _vm._s(
                      _vm._f("declination")(_vm.guide.subscribers, [
                        "obserwator",
                        "obserwatorów",
                        "obserwatorów",
                      ])
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }